import React from 'react';

const Pricing = () => {
  return <div>Pricing Page</div>;
};

export default Pricing;